import { render, staticRenderFns } from "./TagsAdded.vue?vue&type=template&id=2db78823&scoped=true"
import script from "./TagsAdded.vue?vue&type=script&lang=js"
export * from "./TagsAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db78823",
  null
  
)

export default component.exports